module.exports = __webpack_public_path__ + "img/item2video.d1ad43b1.png";